import { resolveTheme, NEUTRAL, onAccent } from '../../designTokens';

// T-12: flikar i pillerstil (samma som Bokningar). `badge` på en flik visar en siffra.
export default function Tabs({ theme, tabs, activeTab, onChange }) {
  const t = theme || resolveTheme();
  return (
    <div className="fr-tabs" style={{
      display: 'inline-flex',
      gap: '4px',
      background: t.card_bg,
      border: `1px solid ${t.card_border}`,
      padding: '4px',
      borderRadius: '10px',
      marginBottom: '16px',
      flexWrap: 'wrap',
      maxWidth: '100%',
      boxSizing: 'border-box',
    }}>
      {tabs.map(tab => {
        const active = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className="fr-tab-btn"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '7px 14px',
              border: 'none',
              borderRadius: '7px',
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: '13px',
              fontWeight: active ? '600' : '500',
              background: active ? t.accent_soft_bg : 'transparent',
              color: active ? t.accent_soft_text : NEUTRAL.muted,
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
            {tab.badge > 0 && (
              <span style={{ borderRadius: '999px', padding: '1px 7px', background: t.accent, color: onAccent(t.accent), fontSize: '11px', fontWeight: '700', lineHeight: '16px' }}>
                {tab.badge > 9 ? '9+' : tab.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
